/**
 * This mixin is used to get Seat Charts balance.
 */
export default {
  data () {
    return {
      selectedSeats: [],
      selectionDescription: null,
      selectionComplete: false,
      initialScale: null,
      initialMinScale: null,
      maxScale: null,
      originX: 0,
      originY: 0,
      autoZoom: null,
      selectedSeatChanged: false
    }
  },
  watch: {
    async 'selectedSeats' (oldValue, newValue) {
      if (newValue && newValue.length && newValue.every((value, index) => value !== oldValue[index])) {
        this.selectedSeatChanged = true
      }
    }
  },
  methods: {
    handleSeatChartInput (input) {
      this.selectedSeats = input.selectedSeats
      this.selectionComplete = input.complete
      this.selectionDescription = input.description
    },
    // Method to handle zooming, combining common logic for zoom in and out
    adjustZoom (delta) {
      this.$refs.zoomer.setData({
        scale: delta,
        originX: this.originX,
        originY: this.originY,
        translateX: 0,
        translateY: 0
      })
    },

    // Zoom in
    onZoomIn () {
      if (this.currentScale < this.maxScale) {
        this.currentScale += 0.1
        this.adjustZoom(this.currentScale)
      }
    },

    // Zoom out
    onZoomOut () {
      this.adjustZoom(this.initialScale)
    },
    onEvent (eventName, e) {
      if (eventName === 'scaling') {
        this.currentScale = e.scale
      }
      if (eventName === 'stopDrag') {
        console.log('stopDrag', e)
        this.handleStopDrag(e)
      }
    },
    handleStopDrag (e) {
      if (this.showFullScreen && this.$q.screen.gt.xs) return

      const seatChart = this.$refs.seatChart?.$el?.getBoundingClientRect()
      if (!seatChart) return

      const horizoneOffsetSpace = seatChart.left
      const verticalOffsetSpace = seatChart.top

      if (event.clientX && event.clientY) {
        const clickPointX = event.clientX
        const clickPointY = event.clientY
        const clickPointXInSeatChart = (clickPointX - horizoneOffsetSpace) * (this.autoZoom - this.initialScale)
        const clickPointYInSeatChart = (clickPointY - verticalOffsetSpace) * Math.max((this.autoZoom - this.initialScale), 0.8)

        setTimeout(() => {
          if (!this.selectedSeatChanged || e.scale >= this.autoZoom || (this.autoZoom - this.initialScale) < 0.06 || e.scale !== this.initialScale) return
          // add amination to auto scale
          const startScale = e.scale
          const startTranslateX = e.translateX
          const startTranslateY = e.translateY

          const targetScale = this.autoZoom
          const targetTranslateX = -clickPointXInSeatChart + e.translateX
          const targetTranslateY = -clickPointYInSeatChart + e.translateY

          let startTime = null
          const duration = 300

          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp

            const elapsed = timestamp - startTime
            const progress = Math.min(elapsed / duration, 1) // Clamp progress to 0-1

            const interpolatedScale = startScale + progress * (targetScale - startScale)
            const interpolatedTranslateX = startTranslateX + progress * (targetTranslateX - startTranslateX)
            const interpolatedTranslateY = startTranslateY + progress * (targetTranslateY - startTranslateY)

            this.$refs.zoomer?.setData({
              scale: interpolatedScale,
              translateX: interpolatedTranslateX,
              translateY: interpolatedTranslateY
            })

            if (progress < 1) {
              requestAnimationFrame(animate)
            } else {
              // Finalize state
              this.currentScale = targetScale
              this.selectedSeatChanged = false
            }
          }

          requestAnimationFrame(animate)
        }, 50)
      } else {
        console.warn('Invalid event coordinates', e)
      }
    }
  }
}
